// Importe as bibliotecas necessárias
import React from 'react';
import * as MuiIcons from '@mui/icons-material';

interface IconProps {
  nameIcon: keyof typeof MuiIcons
  className?: string,
  size: number
}

const DynamicIcon: React.FC<IconProps> = ({ nameIcon, className, size }) => {
  const MuiIcon = (MuiIcons as any)[nameIcon] as any;

  if (MuiIcon) {
    return <MuiIcon className={className} sx={{ fontSize: `${size}px` }} />;
  } else {
    console.error(`Ícone "${nameIcon}" não encontrado.`);
    return <div>Ícone não encontrado</div>;
  }
};

export default DynamicIcon;
